export const YEARS = 'years';
export const NO_UPLOAD_POSSIBLE_MESSAGE = ['Remove diagrams to upload'];
export const DIAGRAM_TYPES = [
  {
    label: 'Cable Plan',
    ref: 'cable_plan'
  },
  {
    label: 'Impedance Map',
    ref: 'impedance_map'
  }
];
export const mappedDiagrams = DIAGRAM_TYPES.reduce((mappedObject, diagramType) => {
  mappedObject[diagramType.ref] = diagramType.label;
  return mappedObject;
}, {});
export const EIGHT_MEGABYTES = 8 * 10e5;
export const HIDE_TOOLTIP = 'bv::hide::tooltip';
export const ERRORS = {
  DEFAULT: 'Error while uploading/removing',
  FILE_LIMIT: 'File size limit is 8MB'
};
